/** CoStar.Api.ListingMessage.ViewModels.Enums.MessageDeliveryType */
export var MessageDeliveryType;
(function (MessageDeliveryType) {
    MessageDeliveryType[MessageDeliveryType["None"] = 0] = "None";
    MessageDeliveryType[MessageDeliveryType["WebNotification"] = 1] = "WebNotification";
    MessageDeliveryType[MessageDeliveryType["Email"] = 2] = "Email";
    MessageDeliveryType[MessageDeliveryType["PhoneCall"] = 3] = "PhoneCall";
    MessageDeliveryType[MessageDeliveryType["WebPushNotification"] = 4] = "WebPushNotification";
    MessageDeliveryType[MessageDeliveryType["SMS"] = 5] = "SMS";
    MessageDeliveryType[MessageDeliveryType["MobileAppPushNotification"] = 6] = "MobileAppPushNotification";
})(MessageDeliveryType || (MessageDeliveryType = {}));
/** CoStar.Api.ListingMessage.ViewModels.Enums.MessageType */
export var MessageType;
(function (MessageType) {
    MessageType[MessageType["None"] = 0] = "None";
    MessageType[MessageType["ListingLead"] = 1] = "ListingLead";
    MessageType[MessageType["BrokerLead"] = 2] = "BrokerLead";
    MessageType[MessageType["TargetedAdLead"] = 3] = "TargetedAdLead";
    MessageType[MessageType["PropertyLead"] = 4] = "PropertyLead";
    MessageType[MessageType["ShareListing"] = 5] = "ShareListing";
    MessageType[MessageType["ShareFavoriteListings"] = 6] = "ShareFavoriteListings";
    MessageType[MessageType["PhoneLead"] = 7] = "PhoneLead";
    MessageType[MessageType["ShareNewsArticle"] = 8] = "ShareNewsArticle";
    MessageType[MessageType["ListingLeadAck"] = 9] = "ListingLeadAck";
    MessageType[MessageType["RequestToViewListingConfidentialData"] = 10] = "RequestToViewListingConfidentialData";
    MessageType[MessageType["ApprovalToViewListingConfidentialData"] = 11] = "ApprovalToViewListingConfidentialData";
    MessageType[MessageType["DownloadSignedListingConfidentialityAgreement"] = 12] = "DownloadSignedListingConfidentialityAgreement";
    MessageType[MessageType["AuctionContactLead"] = 13] = "AuctionContactLead";
    MessageType[MessageType["UserRegistration"] = 14] = "UserRegistration";
    MessageType[MessageType["UserExperienceLead"] = 15] = "UserExperienceLead";
})(MessageType || (MessageType = {}));
/** CoStar.Api.ListingMessage.ViewModels.Enums.MessageEntityType */
export var MessageEntityType;
(function (MessageEntityType) {
    MessageEntityType[MessageEntityType["None"] = 0] = "None";
    MessageEntityType[MessageEntityType["CommercialListing"] = 1] = "CommercialListing";
    MessageEntityType[MessageEntityType["EnterpriseContact"] = 2] = "EnterpriseContact";
    MessageEntityType[MessageEntityType["EnterpriseProperty"] = 3] = "EnterpriseProperty";
    MessageEntityType[MessageEntityType["ListingWebUser"] = 4] = "ListingWebUser";
    MessageEntityType[MessageEntityType["ListingWebWatchListFolder"] = 5] = "ListingWebWatchListFolder";
    MessageEntityType[MessageEntityType["MarketplaceTargetedAdCampaign"] = 6] = "MarketplaceTargetedAdCampaign";
    MessageEntityType[MessageEntityType["NewsArticle"] = 7] = "NewsArticle";
})(MessageEntityType || (MessageEntityType = {}));
/** CoStar.Api.ListingMessage.ViewModels.Enums.MarketingBrand */
export var MarketingBrand;
(function (MarketingBrand) {
    MarketingBrand[MarketingBrand["None"] = 0] = "None";
    MarketingBrand[MarketingBrand["LoopNet"] = 6] = "LoopNet";
    MarketingBrand[MarketingBrand["CityFeet"] = 7] = "CityFeet";
    MarketingBrand[MarketingBrand["Showcase"] = 8] = "Showcase";
    MarketingBrand[MarketingBrand["Realla"] = 13] = "Realla";
    MarketingBrand[MarketingBrand["Belbex"] = 17] = "Belbex";
    MarketingBrand[MarketingBrand["BureauxLocaux"] = 19] = "BureauxLocaux";
    MarketingBrand[MarketingBrand["Other"] = 9999] = "Other";
})(MarketingBrand || (MarketingBrand = {}));
/** CoStar.Api.ListingMessage.ViewModels.Enums.MessageStatus */
export var MessageStatus;
(function (MessageStatus) {
    MessageStatus[MessageStatus["None"] = 0] = "None";
    MessageStatus[MessageStatus["SubmittedByTheSender"] = 1] = "SubmittedByTheSender";
    MessageStatus[MessageStatus["Parsed"] = 2] = "Parsed";
    MessageStatus[MessageStatus["SubmittedToTheDeliveryProvider"] = 3] = "SubmittedToTheDeliveryProvider";
    MessageStatus[MessageStatus["Delivered"] = 4] = "Delivered";
    MessageStatus[MessageStatus["DeliveredToFewRecipients"] = 5] = "DeliveredToFewRecipients";
    MessageStatus[MessageStatus["Error"] = 6] = "Error";
    MessageStatus[MessageStatus["DeletedByTheSystem"] = 7] = "DeletedByTheSystem";
    MessageStatus[MessageStatus["DeletedByTheRecipient"] = 8] = "DeletedByTheRecipient";
    MessageStatus[MessageStatus["QuarantinedDueToAbuseDetected"] = 9] = "QuarantinedDueToAbuseDetected";
    MessageStatus[MessageStatus["QuarantinedDueToSpamDetected"] = 10] = "QuarantinedDueToSpamDetected";
    MessageStatus[MessageStatus["RejectedDueToAbuseDetected"] = 11] = "RejectedDueToAbuseDetected";
    MessageStatus[MessageStatus["RejectedDueToSpamDetected"] = 12] = "RejectedDueToSpamDetected";
    MessageStatus[MessageStatus["RejectedDueToInappropriateContentDetected"] = 13] = "RejectedDueToInappropriateContentDetected";
    MessageStatus[MessageStatus["ReportedAsSpamByTheRecipient"] = 14] = "ReportedAsSpamByTheRecipient";
    MessageStatus[MessageStatus["ReportedAsAbuseByTheRecipient"] = 15] = "ReportedAsAbuseByTheRecipient";
    MessageStatus[MessageStatus["NotDeliveredDueToRecipientLimitExceeded"] = 16] = "NotDeliveredDueToRecipientLimitExceeded";
    MessageStatus[MessageStatus["NotDeliveredDueToSenderRecipientLimitExceeded"] = 17] = "NotDeliveredDueToSenderRecipientLimitExceeded";
    MessageStatus[MessageStatus["NotDeliveredDueToSenderBlockedByRecipient"] = 18] = "NotDeliveredDueToSenderBlockedByRecipient";
    MessageStatus[MessageStatus["PhoneCallAnsweredOrVoicemailLeft"] = 19] = "PhoneCallAnsweredOrVoicemailLeft";
    MessageStatus[MessageStatus["PhoneCallBusy"] = 20] = "PhoneCallBusy";
    MessageStatus[MessageStatus["PhoneCallNotAnswered"] = 21] = "PhoneCallNotAnswered";
    MessageStatus[MessageStatus["PhoneCallCancelled"] = 22] = "PhoneCallCancelled";
    MessageStatus[MessageStatus["PhoneCallCongestion"] = 23] = "PhoneCallCongestion";
    MessageStatus[MessageStatus["PhoneCallChannelUnavailable"] = 24] = "PhoneCallChannelUnavailable";
    MessageStatus[MessageStatus["NotProcessedDueToEntityDetailsNotFound"] = 25] = "NotProcessedDueToEntityDetailsNotFound";
    MessageStatus[MessageStatus["NotDeliveredDueToMultipleReasons"] = 26] = "NotDeliveredDueToMultipleReasons";
    MessageStatus[MessageStatus["ResubmittedByTheSystemUser"] = 27] = "ResubmittedByTheSystemUser";
    MessageStatus[MessageStatus["InvalidOrIncompleteMessageRequest"] = 28] = "InvalidOrIncompleteMessageRequest";
    MessageStatus[MessageStatus["NotDeliveredDueToRecipientListIsEmptyOrBlocked"] = 29] = "NotDeliveredDueToRecipientListIsEmptyOrBlocked";
    MessageStatus[MessageStatus["NotDeliveredDueToSenderIsBlocked"] = 30] = "NotDeliveredDueToSenderIsBlocked";
    MessageStatus[MessageStatus["RejectedDueToLargeContent"] = 31] = "RejectedDueToLargeContent";
    MessageStatus[MessageStatus["NotDeliveredDueToRecipientListIsEmptyOrUnsubscribed"] = 32] = "NotDeliveredDueToRecipientListIsEmptyOrUnsubscribed";
})(MessageStatus || (MessageStatus = {}));
/** CoStar.Api.ListingMessage.ViewModels.Enums.MessageSearchOrderByType */
export var MessageSearchOrderByType;
(function (MessageSearchOrderByType) {
    MessageSearchOrderByType[MessageSearchOrderByType["None"] = 0] = "None";
    MessageSearchOrderByType[MessageSearchOrderByType["Name"] = 1] = "Name";
    MessageSearchOrderByType[MessageSearchOrderByType["SubmittedDate"] = 2] = "SubmittedDate";
})(MessageSearchOrderByType || (MessageSearchOrderByType = {}));
/** CoStar.Api.ListingMessage.ViewModels.Enums.Level */
export var Level;
(function (Level) {
    Level[Level["None"] = 0] = "None";
    Level[Level["Primary"] = 1] = "Primary";
    Level[Level["Secondary"] = 2] = "Secondary";
    Level[Level["Tertiary"] = 3] = "Tertiary";
})(Level || (Level = {}));
/** CoStar.Api.ListingMessage.ViewModels.Enums.MessageSourceDeviceType */
export var MessageSourceDeviceType;
(function (MessageSourceDeviceType) {
    MessageSourceDeviceType[MessageSourceDeviceType["None"] = 0] = "None";
    MessageSourceDeviceType[MessageSourceDeviceType["DesktopWeb"] = 1] = "DesktopWeb";
    MessageSourceDeviceType[MessageSourceDeviceType["MobileWeb"] = 2] = "MobileWeb";
    MessageSourceDeviceType[MessageSourceDeviceType["TabletWeb"] = 3] = "TabletWeb";
    MessageSourceDeviceType[MessageSourceDeviceType["MobileiOSApp"] = 4] = "MobileiOSApp";
    MessageSourceDeviceType[MessageSourceDeviceType["TabletiOSApp"] = 5] = "TabletiOSApp";
    MessageSourceDeviceType[MessageSourceDeviceType["MobileAndroidApp"] = 6] = "MobileAndroidApp";
    MessageSourceDeviceType[MessageSourceDeviceType["TabletAndroidApp"] = 7] = "TabletAndroidApp";
    MessageSourceDeviceType[MessageSourceDeviceType["Phone"] = 8] = "Phone";
})(MessageSourceDeviceType || (MessageSourceDeviceType = {}));
/** CoStar.Api.ListingMessage.ViewModels.Enums.MessageActionType */
export var MessageActionType;
(function (MessageActionType) {
    MessageActionType[MessageActionType["None"] = 0] = "None";
    MessageActionType[MessageActionType["Submitted"] = 1] = "Submitted";
    MessageActionType[MessageActionType["Processed"] = 2] = "Processed";
    MessageActionType[MessageActionType["Delivered"] = 3] = "Delivered";
    MessageActionType[MessageActionType["ReadOnWeb"] = 4] = "ReadOnWeb";
    MessageActionType[MessageActionType["ReadOnEmail"] = 5] = "ReadOnEmail";
    MessageActionType[MessageActionType["ReadOnApp"] = 6] = "ReadOnApp";
    MessageActionType[MessageActionType["ClickedOnReply"] = 7] = "ClickedOnReply";
    MessageActionType[MessageActionType["MarkedAsSpam"] = 8] = "MarkedAsSpam";
    MessageActionType[MessageActionType["MarkedAsNotSpam"] = 9] = "MarkedAsNotSpam";
    MessageActionType[MessageActionType["MarkedAsAbuse"] = 10] = "MarkedAsAbuse";
    MessageActionType[MessageActionType["MarkedAsNotAbuse"] = 11] = "MarkedAsNotAbuse";
    MessageActionType[MessageActionType["Deleted"] = 12] = "Deleted";
    MessageActionType[MessageActionType["Exported"] = 13] = "Exported";
    MessageActionType[MessageActionType["Parsed"] = 14] = "Parsed";
    MessageActionType[MessageActionType["ListingIdUpdated"] = 15] = "ListingIdUpdated";
    MessageActionType[MessageActionType["NotificationWasSent"] = 16] = "NotificationWasSent";
    MessageActionType[MessageActionType["NotificationWasNotSent"] = 17] = "NotificationWasNotSent";
    MessageActionType[MessageActionType["Resubmitted"] = 18] = "Resubmitted";
    MessageActionType[MessageActionType["ReadOnAppFromPushNotification"] = 19] = "ReadOnAppFromPushNotification";
})(MessageActionType || (MessageActionType = {}));
/** CoStar.Api.ListingMessage.ViewModels.Enums.SystemComponent */
export var SystemComponent;
(function (SystemComponent) {
    SystemComponent[SystemComponent["None"] = 0] = "None";
    SystemComponent[SystemComponent["LoopNetWebsite"] = 1] = "LoopNetWebsite";
    SystemComponent[SystemComponent["CityFeetWebsite"] = 2] = "CityFeetWebsite";
    SystemComponent[SystemComponent["ShowCaseWebsite"] = 3] = "ShowCaseWebsite";
    SystemComponent[SystemComponent["MarketplaceListingServiceScheduler"] = 4] = "MarketplaceListingServiceScheduler";
    SystemComponent[SystemComponent["MarketplaceNotificationSystem"] = 5] = "MarketplaceNotificationSystem";
    SystemComponent[SystemComponent["SqlJobMergedListingLeads"] = 6] = "SqlJobMergedListingLeads";
    SystemComponent[SystemComponent["LoopNetAndroidMobileApp"] = 7] = "LoopNetAndroidMobileApp";
    SystemComponent[SystemComponent["LoopNetAndroidTabletApp"] = 8] = "LoopNetAndroidTabletApp";
    SystemComponent[SystemComponent["LoopNetiOSMobileApp"] = 9] = "LoopNetiOSMobileApp";
    SystemComponent[SystemComponent["LoopNetiOSTabletApp"] = 10] = "LoopNetiOSTabletApp";
    SystemComponent[SystemComponent["CityFeetAndroidMobileApp"] = 11] = "CityFeetAndroidMobileApp";
    SystemComponent[SystemComponent["CityFeetAndroidTabletApp"] = 12] = "CityFeetAndroidTabletApp";
    SystemComponent[SystemComponent["CityFeetiOSMobileApp"] = 13] = "CityFeetiOSMobileApp";
    SystemComponent[SystemComponent["CityFeetiOSTabletApp"] = 14] = "CityFeetiOSTabletApp";
    SystemComponent[SystemComponent["ShowCaseAndroidMobileApp"] = 15] = "ShowCaseAndroidMobileApp";
    SystemComponent[SystemComponent["ShowCaseAndroidTabletApp"] = 16] = "ShowCaseAndroidTabletApp";
    SystemComponent[SystemComponent["ShowCaseiOSMobileApp"] = 17] = "ShowCaseiOSMobileApp";
    SystemComponent[SystemComponent["ShowCaseiOSTabletApp"] = 18] = "ShowCaseiOSTabletApp";
    SystemComponent[SystemComponent["LoopNetControlCenter"] = 19] = "LoopNetControlCenter";
    SystemComponent[SystemComponent["ListingManagerAndroidMobileApp"] = 20] = "ListingManagerAndroidMobileApp";
    SystemComponent[SystemComponent["ListingManagerAndroidTabletApp"] = 21] = "ListingManagerAndroidTabletApp";
    SystemComponent[SystemComponent["ListingManageriOSMobileApp"] = 22] = "ListingManageriOSMobileApp";
    SystemComponent[SystemComponent["ListingManageriOSTabletApp"] = 23] = "ListingManageriOSTabletApp";
    SystemComponent[SystemComponent["LoopLinkLegacyWebsite"] = 24] = "LoopLinkLegacyWebsite";
    SystemComponent[SystemComponent["LoopLink10Website"] = 25] = "LoopLink10Website";
    SystemComponent[SystemComponent["ReallaWebsite"] = 26] = "ReallaWebsite";
    SystemComponent[SystemComponent["ReallaAndroidMobileApp"] = 27] = "ReallaAndroidMobileApp";
    SystemComponent[SystemComponent["ReallaAndroidTabletApp"] = 28] = "ReallaAndroidTabletApp";
    SystemComponent[SystemComponent["ReallaiOSMobileApp"] = 29] = "ReallaiOSMobileApp";
    SystemComponent[SystemComponent["ReallaiOSTabletApp"] = 30] = "ReallaiOSTabletApp";
    SystemComponent[SystemComponent["CoStarSuiteWebsite"] = 31] = "CoStarSuiteWebsite";
    SystemComponent[SystemComponent["CoStarSuiteAndroidMobileApp"] = 32] = "CoStarSuiteAndroidMobileApp";
    SystemComponent[SystemComponent["CoStarSuiteAndroidTabletApp"] = 33] = "CoStarSuiteAndroidTabletApp";
    SystemComponent[SystemComponent["CoStarSuiteiOSMobileApp"] = 34] = "CoStarSuiteiOSMobileApp";
    SystemComponent[SystemComponent["CoStarSuiteiOSTabletApp"] = 35] = "CoStarSuiteiOSTabletApp";
    SystemComponent[SystemComponent["ResearchPortfolioWebsite"] = 36] = "ResearchPortfolioWebsite";
    SystemComponent[SystemComponent["BelbexWebSite"] = 37] = "BelbexWebSite";
    SystemComponent[SystemComponent["BelbexAndroidMobileApp"] = 38] = "BelbexAndroidMobileApp";
    SystemComponent[SystemComponent["BelbexAndroidTabletApp"] = 39] = "BelbexAndroidTabletApp";
    SystemComponent[SystemComponent["BelbexiOSMobileApp"] = 40] = "BelbexiOSMobileApp";
    SystemComponent[SystemComponent["BelbexiOSTabletApp"] = 41] = "BelbexiOSTabletApp";
    SystemComponent[SystemComponent["Other"] = 99] = "Other";
})(SystemComponent || (SystemComponent = {}));
/** CoStar.Api.ListingMessage.ViewModels.Enums.MessageRecipientIdentifierType */
export var MessageRecipientIdentifierType;
(function (MessageRecipientIdentifierType) {
    MessageRecipientIdentifierType[MessageRecipientIdentifierType["None"] = 0] = "None";
    MessageRecipientIdentifierType[MessageRecipientIdentifierType["MessageRecipientId"] = 1] = "MessageRecipientId";
    MessageRecipientIdentifierType[MessageRecipientIdentifierType["Email"] = 2] = "Email";
    MessageRecipientIdentifierType[MessageRecipientIdentifierType["UserId"] = 3] = "UserId";
    MessageRecipientIdentifierType[MessageRecipientIdentifierType["ContactId"] = 4] = "ContactId";
})(MessageRecipientIdentifierType || (MessageRecipientIdentifierType = {}));
